<div class="card flex justify-center">
    <p-stepper [(value)]="step" [linear]="true" class="w-[95vw] max-w-[1400px]">
        <p-step-list>
            <p-step [value]="1" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-building"></i>
                        </span>
                        <span class="text-sm text-center">1</span>
                    </button>
                </ng-template>
            </p-step>

            <p-step [value]="2" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-file-excel"></i>
                        </span>
                        <span class="text-sm text-center">2</span>
                    </button>
                </ng-template>
            </p-step>

            <p-step [value]="3" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-user-edit"></i> </span>
                        <span class="text-sm text-center">3</span>
                    </button>
                </ng-template>
            </p-step>

            <p-step [value]="4" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-tag"></i> </span>
                        <span class="text-sm text-center">4</span>
                    </button>
                </ng-template>
            </p-step>

            <p-step [value]="5" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-at"></i> </span>
                        <span class="text-sm text-center">5</span>
                    </button>
                </ng-template>
            </p-step>

            <p-step [value]="6" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-map-marker"></i> </span>
                        <span class="text-sm text-center">6</span>
                    </button>
                </ng-template>
            </p-step>

            <p-step [value]="7" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-phone"></i> </span>
                        <span class="text-sm text-center">6</span>
                    </button>
                </ng-template>
            </p-step>

            <!-- <p-step [value]="8" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-credit-card"></i> </span>
                        <span class="text-sm text-center">7</span>
                    </button>
                </ng-template>
            </p-step>

            <p-step [value]="9" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-users"></i> </span>
                        <span class="text-sm text-center">8</span>
                    </button>
                </ng-template>
            </p-step>

            <p-step [value]="10" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-hashtag"></i> </span>
                        <span class="text-sm text-center">9</span>
                    </button>
                </ng-template>
            </p-step> 

            <p-step [value]="7" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-briefcase"></i> </span>
                        <span class="text-sm text-center">7</span>
                    </button>
                </ng-template>
            </p-step>-->

            <p-step [value]="8" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-link"></i> </span>
                        <span class="text-sm text-center">8</span>
                    </button>
                </ng-template>
            </p-step>

            <p-step [value]="9" class="flex flex-row flex-auto gap-4">
                <ng-template #content let-activateCallback="activateCallback" let-value="value">
                    <button
                        class="bg-transparent border-0 inline-flex flex-col gap-2"
                        (click)="activateCallback()">
                        <span
                            class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                            [ngClass]="{
                                'bg-primary text-primary-contrast border-primary': value <= step,
                                'border-surface': value > step
                            }"
                        >
                            <i class="pi pi-check-circle"></i> </span>
                        <span class="text-sm text-center">9</span>
                    </button>
                </ng-template>
            </p-step>
        </p-step-list>


        <p-step-panels>
            <p-step-panel [value]="1">
                <ng-template #content let-activateCallback="activateCallback">
                    <app-basic-info
                        [entityType]="entityType"
                        (entityTypeChange)="onEntityTypeChanged($event)"
                        [(businessName)]="businessName"
                        [(businessType)]="businessType"
                        [(businessNumber)]="businessNumber"
                        [(isActive)]="isActive"
                        (nextStep)="onNext(activateCallback, isEntityTypeCustomer(entityType) ? 1 : 2)"
                    ></app-basic-info>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="2">
                <ng-template #content let-activateCallback="activateCallback">
                    <app-index-insert-step
                        (nextStep)="onNext(activateCallback, 2)"
                        (prevStep)="onPrevious(activateCallback, 2)"></app-index-insert-step>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="3">
                <ng-template #content let-activateCallback="activateCallback">
                    <app-profilers
                        [(profiles)]="profiles"
                        (nextStep)="onNext(activateCallback, 3)"
                        (prevStep)="onPrevious(activateCallback, 3, isEntityTypeCustomer(entityType) ? 1 : 2)"
                        (skipToLastStep)="onSkipToLastStep(activateCallback)"
                    ></app-profilers>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="4">
                <ng-template #content let-activateCallback="activateCallback">
                    <app-additional-names
                        [(additionalNames)]="additionalNames"
                        (nextStep)="onNext(activateCallback, 4)"
                        (prevStep)="onPrevious(activateCallback, 4)"
                    ></app-additional-names>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="5">
                <ng-template #content let-activateCallback="activateCallback">
                    <app-email
                        [(emails)]="emails"
                        (nextStep)="onNext(activateCallback, 5)"
                        (prevStep)="onPrevious(activateCallback, 5)"
                    ></app-email>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="6">
                <ng-template #content let-activateCallback="activateCallback">
                    <app-addresses
                        [(addresses)]="addresses"
                        (nextStep)="onNext(activateCallback, 6)"
                        (prevStep)="onPrevious(activateCallback, 6)"
                    ></app-addresses>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="7">
                <ng-template #content let-activateCallback="activateCallback">
                    <app-phone-numbers
                        [(phoneNumbers)]="phoneNumbers"
                        (nextStep)="onNext(activateCallback, 7)"
                        (prevStep)="onPrevious(activateCallback, 7)"
                    ></app-phone-numbers>
                </ng-template>
            </p-step-panel>
                    
            <p-step-panel [value]="8">
                <ng-template #content let-activateCallback="activateCallback">
                    <app-urls
                        [(urls)]="urls"
                        (nextStep)="onNext(activateCallback, 8)"
                        (prevStep)="onPrevious(activateCallback, 8)"
                    ></app-urls>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="9">
                <ng-template #content let-activateCallback="activateCallback">
                    <app-summary
                        [(entityType)]="entityType"
                        [(businessName)]="businessName"
                        [(businessNumber)]="businessNumber"
                        (prevStep)="onPrevious(activateCallback, 9)"
                        (save)="saveAccount()"
                        (cancel)="cancel()"
                    ></app-summary>
                </ng-template>
            </p-step-panel>
        </p-step-panels>
    </p-stepper>
</div>